<template>
  <a-modal
    :width="modalWidth"
    :visible="visible"
    :title="dialogTitle"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
    cancelText="关闭"
    wrapClassName="ant-modal-cust-warp"
    >
    <!--部门树-->
    <a-tree
      :multiple="false"
      :expanded-keys="expandedKeys"
      :auto-expand-parent="autoExpandParent"
      allowClear="true"
      @expand="onExpand"
      :dropdownStyle="{maxHeight:'200px',overflow:'auto'}"
      :treeData="departTree"
      placeholder="请选择上级部门"
      @select="handleDepartSelect"
      >
    </a-tree>
  </a-modal>
</template>

<script>
  import pick from 'lodash.pick'
  import { getAction } from '@/api/manage'
  import { selectCompanyInfoTree,selectCompanyInfoByUserCode } from '@/api/api'
  export default {
    name: "DepartWindow",
    data () {
      return {
        expandedKeys: [],
        autoExpandParent: false,
        modalWidth:700,
        departTree:[],
        title:"选择分公司",
        visible: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        selectValueObj:{
          companyidh:"",
          companynameh:""
        }
      }
    },
    props:{
      permissionType:{
        type:String,
        default:"some"
      }
    },
    created() {
      this.queryDepartTree();
    },
    methods: {
      onExpand(expandedKeys) {
        // if not set autoExpandParent to false, if children expanded, parent can not collapse.
        // or, you can remove all expanded children keys.
        this.expandedKeys = expandedKeys;
        this.autoExpandParent = false;
      },
      open(){
        this.visible = true;
      },
      close () {
        this.autoExpandParent = true;
        this.$emit('close');
        this.visible = false;
      },
      handleSubmit () {
        if(!this.selectValueObj.companyidh || !this.selectValueObj.companynameh){
          this.$message.error("请选择正确的二级经销商")
          return
        }
        this.$emit("selected",this.selectValueObj)
        this.close()
      },
      handleCancel () {
        this.close()
      },
      queryDepartTree(){
        if(this.permissionType==='some'){
          selectCompanyInfoByUserCode().then((res)=>{
            if(res.success){
              this.departTree = this.toTree(res.result);
              this.expandedKeys = [this.departTree[0].id];
              this.autoExpandParent = true;
            }
          })
        }else if(this.permissionType==='all'){
          selectCompanyInfoTree().then((res)=>{
            if(res.success){
              this.departTree = this.toTree(res.result);
              this.expandedKeys = [this.departTree[0].id];
              this.autoExpandParent = true;
            }
          })
        }
        
      },
      toTree(data) {
        let result = []
        if (!Array.isArray(data)) {
          return result
        }
        data.forEach((item, index) => {
          data[index].title = item.companynameh
          data[index].key = item.id
          data[index].value = item.id
          data[index].companyidh = item.companyidh
          data[index].scopedSlots = { title: 'title' }
          delete item.children
        })
        let map = {}
        data.forEach((item) => {
          map[item.id] = item
        })
        data.forEach((item) => {
          let parent = map[item.parentId]
          if (parent) {
            ;(parent.children || (parent.children = [])).push(item)
          } else {
            result.push(item)
          }
        })
        return result
      },
      handleDepartSelect(value,node,extra){
        console.log(node)
        console.log(node.node._props.dataRef.companyidh)
        console.log(node.node._props.dataRef.companynameh)
        this.$set(this.selectValueObj,"companyidh",node.node._props.dataRef.companyidh)
        this.$set(this.selectValueObj,"companynameh",node.node._props.dataRef.companynameh)
      }
    },
    computed:{
      dialogTitle(){
        if(!this.selectValueObj.companynameh){
          return "请选择"
        }
        return `当前选择：${this.selectValueObj.companynameh}`
      }
    }
  }
</script>

<style scoped>
  .ant-table-tbody .ant-table-row td{
    padding-top:10px;
    padding-bottom:10px;
  }
  /deep/.ant-modal-cust-warp .ant-modal-content {
      height: calc(100vh - 120px) !important;
      overflow-y: hidden;
  }
</style>